import { render, staticRenderFns } from "./GroupsIcon.vue?vue&type=template&id=4f842e1b&scoped=true&"
import script from "./GroupsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GroupsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f842e1b",
  null
  
)

export default component.exports